/**
 * Package catalog + bank-account wire DTOs (Packages, Leads & Payment
 * Verification, P21-T02). Read-only from the client's perspective; the
 * coach-portal Settings > Packages admin UI can edit price/description/
 * active status and feature attachments (edit-only — no create/delete of
 * packages, `tier` is never editable), manage the Feature catalog, and
 * manage bank accounts, all gated behind `settings:workspace-manage`.
 */
// ── Tier-based feature gating (P21-T06) ──────────────────────────────
// Tiers are strictly ordered/cumulative (docs/packages.md) — a client's
// `activeTier` (see `ClientAuthDTO`) unlocks everything at or below it.
// Shared here (not just client-portal) so the UI gate and the API's
// defense-in-depth re-check can never drift apart.
/** Tier 1 ("Basic Assessment Level") includes no coaching/healing/review
 * sessions at all — only Tier 2+ packages include any sessions to book. */
export const MIN_TIER_FOR_BOOKINGS = 2;
/** Tier 1 doesn't include a Brain SWOT Report — only Tier 2+ does. */
export const MIN_TIER_FOR_BRAIN_SWOT = 2;
/** `null` means "no verified purchase yet" — never entitled to anything gated. */
export function hasTierAccess(activeTier, requiredTier) {
    return activeTier !== null && activeTier >= requiredTier;
}
//# sourceMappingURL=packages.js.map